import React from "react";
import { createRoot } from "react-dom/client";

import NextApp from "./NextApp";
import registerServiceWorker from "./registerServiceWorker";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import { sentryData } from "./constants";

// Suppress ResizeObserver warning - this is a known browser issue with Ant Design
// that doesn't affect functionality
if (typeof window !== 'undefined') {
  const originalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends originalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        try {
          callback(entries, observer);
        } catch (error) {
          // Suppress the specific error
          if (error.message && error.message.includes('loop completed with undelivered notifications')) {
            return;
          }
          throw error;
        }
      });
    }
  };
}

Sentry.init({
  dsn: sentryData.SENTRY_DSN,
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

// Wrap the rendering in a function:
const render = (Component) => {
  const root = createRoot(document.getElementById("root"));
  root.render(<Component />);
};

// Do this once
registerServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept("./NextApp", () => {
    render(NextApp);
  });
}
